import { render, staticRenderFns } from "./DevicesCardDevicesList.vue?vue&type=template&id=1f80a8d5&scoped=true&"
import script from "./DevicesCardDevicesList.vue?vue&type=script&lang=ts&"
export * from "./DevicesCardDevicesList.vue?vue&type=script&lang=ts&"
import style0 from "./DevicesCardDevicesList.vue?vue&type=style&index=0&id=1f80a8d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80a8d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
